import { Component, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FlexIvrSettings } from '@wephone-core/service/flexivr_settings';
import { PhoneCall } from '../../services/phone/phonecall';
import { PhoneService } from '@wephone-app-phone/services/phone/phone.service';
import { IUserEntity } from '@wephone-core/model/entity/user.i';

@Component({
  selector: 'call-standby',
  templateUrl: 'call-standby.html',
  styleUrls: [ './call-standby.scss' ],
  animations: [
    trigger('keypad', [
      state(
        'visible',
        style({
          opacity: 1,
          display: 'block'
        })
      ),
      state(
        'invisible',
        style({
          opacity: 0,
          display: 'none'
        })
      ),
      transition('visible => invisible', animate('0s')),
      transition('invisible => visible', animate('0.5s'))
    ]),
    trigger('buttons', [
      state(
        'visible',
        style({
          opacity: 1,
          display: 'block'
        })
      ),
      state(
        'invisible',
        style({
          opacity: 0,
          display: 'none'
        })
      ),
      transition('visible => invisible', animate('0s')),
      transition('invisible => visible', animate('0.5s'))
    ])
  ]
})
export class CallStandbyComponent {
  @Input() public call: PhoneCall;

  constructor(public phoneService: PhoneService, private settings: FlexIvrSettings) {}

  endCall(): void {
    this.call.hangup();
  }

  uimodeEnterprise(): boolean {
    return this.settings.btEnterprise();
  }

  uimodeHotel(): boolean {
    return this.settings.btHotel();
  }

  uimodeCallCenter(): boolean {
    return this.settings.btCallCenter();
  }

  toggleHold(): void {
    this.phoneService.setOnhold(this.call, !this.call.isOnhold());
  }

  toggleMute(): void {
    this.call.toggleMute();
  }

  get queueName(): string {
    if (this.call.queue) {
      return this.call.queue.queue_name;
    }
  }

  get groupName(): string {
    if (this.call.group) {
      return this.call.group.name;
    }
  }

  get user(): IUserEntity {
    if (this.call.sipphone && this.call.sipphone.user) {
      return this.call.sipphone.user;
    }
  }
}
